const loadState = () => {
  try {
    const serializedState = localStorage.getItem("asc925");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("asc925", serializedState);
  } catch (err) {
    throw new Error(err);
  }
};

export { loadState, saveState };
